const TableRowSkeleton = () => (
  <tr className="w-full border-b border-gray-100 last-of-type:border-none [&:first-child>td:first-child]:rounded-tl-lg [&:first-child>td:last-child]:rounded-tr-lg [&:last-child>td:first-child]:rounded-bl-lg [&:last-child>td:last-child]:rounded-br-lg">
     {/* Id */}
     <td className="whitespace-nowrap px-6 py-3">
      <div className="h-6 w-32 rounded bg-gray-200"></div>
    </td>
    {/* Name */}
    <td className="whitespace-nowrap px-6 py-3">
      <div className="h-6 w-32 rounded bg-gray-200"></div>
    </td>
    {/* Registration No */}
    <td className="px-6 py-3">
      <div className="h-6 w-24 rounded bg-gray-200"></div>
    </td>
    {/* Website */}
    <td className="px-6 py-3">
      <div className="h-6 w-32 rounded bg-gray-200"></div>
    </td>
    {/* Income */}
    <td className="px-6 py-3">
      <div className="h-6 w-20 rounded bg-gray-200"></div>
    </td>
    {/* Expenditure */}
    <td className="px-6 py-3">
      <div className="h-6 w-20 rounded bg-gray-200"></div>
    </td>
    {/* Actions */}
    <td className="whitespace-nowrap px-6 py-3">
      <div className="flex items-center justify-start gap-2">
        <div className="h-8 w-8 rounded-full bg-gray-200"></div>
        <div className="h-8 w-8 rounded-full bg-gray-200"></div>
      </div>
    </td>
  </tr>
);

const MobileCardSkeleton = () => (
  <div className="mb-2 w-full rounded-md bg-white p-4">
    {/* Name */}
    <div className="h-6 w-32 rounded bg-gray-200 mb-4"></div>
    {/* Registration */}
    <div className="flex items-center gap-2 pb-4 mt-2">
      <div className="h-5 w-24 bg-gray-200 rounded"></div>
      <div className="h-5 w-24 bg-gray-200 rounded"></div>
    </div>
    {/* Website */}
    <div className="flex items-center gap-2 mb-2">
      <div className="h-5 w-16 bg-gray-200 rounded"></div>
      <div className="h-5 w-32 bg-gray-200 rounded"></div>
    </div>
    {/* Income */}
    <div className="flex items-center gap-2 mb-2">
      <div className="h-5 w-12 bg-gray-200 rounded"></div>
      <div className="h-5 w-20 bg-gray-200 rounded"></div>
    </div>
    {/* Expenditure */}
    <div className="flex items-center gap-2 mb-4">
      <div className="h-5 w-20 bg-gray-200 rounded"></div>
      <div className="h-5 w-20 bg-gray-200 rounded"></div>
    </div>
    {/* Actions */}
    <div className="w-full flex items-center justify-center gap-2">
      <div className="h-8 w-8 rounded-full bg-gray-200"></div>
      <div className="h-8 w-8 rounded-full bg-gray-200"></div>
    </div>
  </div>
);

export default function CharitiesSkeleton() {
  return (
    <div className="animate-pulse">
      {/* Mobile layout */}
      <div className="lg:hidden">
        <MobileCardSkeleton />
        <MobileCardSkeleton />
        <MobileCardSkeleton />
        <MobileCardSkeleton />
      </div>

      {/* Desktop table */}
      <table className="hidden min-w-full text-gray-900 text-left lg:table">
        <thead className="rounded-lg text-left text-sm font-normal">
          <tr>
            <th className="px-6 py-3">Id</th>
            <th className="px-6 py-3">Name</th>
            <th className="px-6 py-3">Registration No</th>
            <th className="px-6 py-3">Website</th>
            <th className="px-6 py-3">Income</th>
            <th className="px-6 py-3">Expenditure</th>
            <th className="px-6 py-3">Edit</th>
          </tr>
        </thead>
        <tbody className="bg-white">
          <TableRowSkeleton />
          <TableRowSkeleton />
          <TableRowSkeleton />
          <TableRowSkeleton />
          <TableRowSkeleton />
        </tbody>
      </table>
    </div>
  );
}
